import { configureStore } from "@reduxjs/toolkit";

// settings
import settings from "../features/settings/Slice";

// auth
import auth from "../features/auth/Slice";

// masters
import masters from "./masters";

// common
import common from "../features/admin/common/Slice";

//usermanagement
import usermanagement from "./usermanagement";

//helpsection
import helpsection from "./helpsection";

//setting
import setting from "./setting";

// managewallet
import managewallet from "./managewallet";

// Manage Pickup Drop
import manage_pickup_drop from "./manage_pickup_drop";

// managewallethistory
import managewallethistory from "./managewallethistory";

// manage_reports
import manage_reports from "./manage_reports";

// manage_withdraw_request
import manage_withdraw_request from "./manage_withdraw_request";

// broadcast_notification
import broadcast_notification from "./broadcast_notification";

// Service invoice
import service_invoice from "./service_invoice";

// Ambassador invoice
import ambassador_invoice from "./ambassador_invoice";

// trip Location
import trip_location from "./trip_location";

// User Admin
import manage_superadmin_admin from "./manage_superadmin_admin";

export const store = configureStore({
         reducer: {
           // settings
           settings: settings,

           //auth
           auth: auth,

           //masters
           masters: masters,

           //common
           common: common,

           //user management
           usermanagement,

           //helpsection
           helpsection,

           //setting
           setting,

           // managewallet
           managewallet,

           // manage_pickup_drop
           manage_pickup_drop,

           // managewallethistory
           managewallethistory,

           // manage_reports
           manage_reports,

           // manage_withdraw_request
           manage_withdraw_request,

           // broadcast_notification
           broadcast_notification,

           // service_invoice
           service_invoice,

           // ambassador_invoice
           ambassador_invoice,

           // trip_location
           trip_location,

           // manage_admin
           manage_superadmin_admin,
         },
       });
